<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-office-building"
          color="primary"
          class="small-icon"
          :title="id ? $i18n.t('Edit Inventory') : $i18n.t('Create Inventory')"
        >
          <v-form id="form">
            <v-container class="py-0" style="margin-top: 20px">
              <v-row>
                <v-col cols="12" md="3">
                  {{ $i18n.t("Article") }} : {{ inventory.articleName }}
                </v-col>

                <v-col cols="12" md="3">
                  {{ $i18n.t("Bill No.") }} :
                  {{ inventory.purchase ? inventory.purchase.billNo : "" }}
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('Total Units')"
                    dense
                    type="number"
                    v-model="inventory.units"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  {{ $i18n.t("Available") }} : {{ inventory.available }}
                </v-col>

                <v-col cols="12" md="3">
                  <z-date-picker
                    :label="$i18n.t('Purchase Date')"
                    type="number"
                    v-model="inventory.purchaseDate"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <z-date-picker
                    :label="$i18n.t('Expiry Date')"
                    type="number"
                    v-model="inventory.expiryDate"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-simple-table dense style="width: 100%">
                  <thead class="thead">
                    <tr>
                      <th colspan="2">
                        {{ $i18n.t("Handed to") }}
                      </th>
                      <th class="text-center">
                        {{ $i18n.t("Units") }}
                      </th>
                      <th class="text-center">
                        {{ $i18n.t("Wastage") }}
                      </th>
                      <th class="text-center">
                        {{ $i18n.t("Handed At") }}
                      </th>
                      <th class="text-center">
                        {{ $i18n.t("Handed By") }}
                      </th>
                      <th class="text-right">{{ $i18n.t("Action") }}</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(item, index) in inventory.consumptions"
                    :key="index"
                  >
                    <tr>
                      <td>
                        <z-driver-select
                          idOnly
                          v-model="item.driver_id"
                        ></z-driver-select>
                      </td>

                      <td>
                        <z-supervisor-select
                          idOnly
                          v-model="item.user_id"
                        ></z-supervisor-select>
                      </td>

                      <td class="text-center">
                        <v-text-field
                          type="number"
                          v-model="item.units"
                        ></v-text-field>
                      </td>

                      <td class="text-center">
                        <v-checkbox v-model="item.wastage" />
                      </td>

                      <td class="text-center">
                        {{ item.dateTime }}
                      </td>

                      <td class="text-center">{{ item.user }}</td>

                      <td>
                        <v-btn
                          class="float-right"
                          text
                          fab
                          x-small
                          color="red"
                          @click="remove(inventory.consumptions, index)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-row style="margin-bottom: 30px">
                  <v-col cols="12">
                    <v-btn
                      color="blue"
                      x-small
                      style="float: right"
                      class="client-headers"
                      @click="inventory.consumptions.push({})"
                      >{{ $i18n.t("Add New") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class InventoryEdit extends Vue {
  inventory = {};

  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      this.inventory = await doPost(
        "/api/article/inventory/save",
        this.inventory
      );
      this.$router.push("/inventory/" + this.inventory._id);
      this.get(this.inventory._id);
      common.showMessage("Saved Successfully");
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.inventory = await doGet("/api/article/inventory/" + id + "/detail");
      this.id = this.inventory._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.client-headers {
  text-transform: none;
  /* left: 10px; */
  right: 10px;
  font-size: 12px;
}
</style>
